import React from 'react';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';
import styles from './OneTimeMessagesDismissedList.less';
import {
  useOneTimeMessagesDismissedQuery,
  useDeleteOneTimeMessagesDismissedMutation,
} from '@trello/graphql/generated';
import { Spinner } from 'app/src/components/Spinner';
import { Icon, IconColor, IconName } from 'app/common/components/controls';

export interface OneTimeMessagesDismissedListProps {
  memberId: string;
}

export const OneTimeMessagesDismissedList: React.FunctionComponent<OneTimeMessagesDismissedListProps> = ({
  memberId,
}) => {
  const { data, error, loading } = useOneTimeMessagesDismissedQuery({
    variables: { memberId },
  });
  const [
    deleteOneTimeMessagesDismissed,
    { loading: deleteLoading, error: deleteError },
  ] = useDeleteOneTimeMessagesDismissedMutation();
  const createClickHandler = (message: string) => () => {
    deleteOneTimeMessagesDismissed({
      variables: {
        memberId,
        message,
      },
    });
  };

  const oneTimeMessagesDismissed =
    data && data.member && data.member.oneTimeMessagesDismissed;

  if (error) {
    console.error(error);
  }
  if (deleteError) {
    console.error(deleteError);
  }

  return (
    <div>
      <p>Click a oneTimeMessageDismissed to delete it.</p>
      <p>
        (This API endpoint is only available in development and for members in
        the trelloinc team.)
      </p>
      {loading && <Spinner centered />}
      {data && (
        <PopoverMenu className={styles.popoverMenu}>
          {oneTimeMessagesDismissed &&
            oneTimeMessagesDismissed.map(
              (message) =>
                message && (
                  <PopoverMenuButton
                    key={message}
                    className={styles.oneTimeMessageDismissedButton}
                    disabled={deleteLoading}
                    onClick={createClickHandler(message)}
                  >
                    <span className={styles.oneTimeMessageDismissedButtonInner}>
                      <span className={styles.iconWrapper}>
                        <Icon
                          small
                          name={IconName.Close}
                          color={IconColor.Gray}
                        />
                      </span>
                      <span className={styles.message}>{message}</span>
                    </span>
                  </PopoverMenuButton>
                ),
            )}
        </PopoverMenu>
      )}
    </div>
  );
};
